import api from '@pray/shared/utils/api';

export async function createArtistContent({
  artistId = null,
  title = null,
  primaryAudioUrl = null,
  primaryAudioFileDuration = null,
  primaryAudioFileSize = null,
  primaryVideoUrl = null,
  primaryVideoFileDuration = null,
  primaryVideoFileSize = null,
  sourceLocaleCode = null,
}) {
  if (!artistId) throw Error('ID is required');

  if (!primaryAudioUrl && !primaryVideoUrl) throw Error('Audio or video file URL is required');

  const data = {
    premium_type: 'free',
  };

  if (title) {
    data.title = title;
  }

  // The original language this content was authored in. Omitted (null) = English default.
  if (sourceLocaleCode) {
    data.source_locale_code = sourceLocaleCode;
  }

  if (primaryAudioUrl) {
    if (!primaryAudioFileDuration) throw Error('Audio file duration is required');
    if (!primaryAudioFileSize) throw Error('Audio file size is required');

    data.primary_audio_url = primaryAudioUrl;
    data.primary_audio_file_duration = primaryAudioFileDuration;
    data.primary_audio_file_size = primaryAudioFileSize;
  } else if (primaryVideoUrl) {
    if (!primaryVideoFileSize) throw Error('Video file size is required');

    data.primary_video_url = primaryVideoUrl;
    // Duration is best-effort: the browser can't read it for codecs it can't
    // decode (e.g. MPEG-4 Part 2 / DivX), so it arrives as 0. Send it anyway —
    // the server still ingests the video and transcodes it. We send 0 rather
    // than omitting the key so the create payload stays valid.
    data.primary_video_file_duration = primaryVideoFileDuration || 0;
    data.primary_video_file_size = primaryVideoFileSize;
  }

  const url = `/web/studio/artists/${artistId}/content`;
  const response = await api.executePostRequest(url, data);

  return response.data.data;
}
